const routes = [
  {
    path: "/docuforms/:uid",
    name: "docuform",
    component: () => import(/* webpackChunkName: "DocuformPage" */ "./views/DocuformPage"),
    props: route => ({
      uid: route.params.uid
    })
  }
];

export default routes;
